import DonorInfo from "../api/models/Donor"

export default function FormatName(donor: DonorInfo): string {
  if (donor) {
    return `${donor.firstName} ${donor.lastName}`
  }
  return ""
}
